import { render, staticRenderFns } from "./bot-command-config.vue?vue&type=template&id=373a9e73&"
import script from "./bot-command-config.vue?vue&type=script&lang=js&"
export * from "./bot-command-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports